
<template>
  <div class="pdf-page-content">
    <vue-pdf
      v-for="page in numOfPages"
      :key="page"
      :page="page"
      :src="source"
    />
  </div>
</template>

<script>
import { reactive, onMounted, toRefs, nextTick, computed, } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { VuePdf, createLoadingTask } from 'vue3-pdfjs/esm';
export default {
  name: 'pdf',
  components: { VuePdf },
  setup() {
    const store = useStore()
    const route = useRoute();
    const state = reactive({
      title: 'pdf',
      isLogin: false, // 是否已登录
      // source: '@/assets/线上服务协议.pdf', //预览pdf文件地址
      pageNum: 1, //当前页面
      numOfPages: 0,
      source: undefined,
    })

    document.title = route.query.type == 1 ? '用户协议' : '隐私政策'

    onMounted(async () => {
      switch (route.query.type) {
        // 1用户协议2隐私
        case '1':
          state.source = getDeafultPdfUrl('1')
          break;
        case '2':
          state.source = getDeafultPdfUrl('2')
          break;
      }
      const loadingTask = createLoadingTask(state.source)

      loadingTask.promise.then((pdf) => {
        state.numOfPages = pdf.numPages
      })
      // window.addEventListener('popstate', popstateFun, false);// 首页禁止回退
    })

    const getDeafultPdfUrl = (type) => {
      let map = {
        1: 'https://elife-dev.oss-cn-shanghai.aliyuncs.com/20240611/20240611151101AerX.pdf',
        2: 'https://elife-dev.oss-cn-shanghai.aliyuncs.com/20240611/20240611151133KXBM.pdf',
      } // 1用户协议2隐私
      return map[type]
    };

    nextTick(() => { })

    return {
      ...toRefs(state),
    }
  },
}
</script>

<style lang="less" scoped >
.pdf-page-content {
  background: #f6f6f6;
  min-height: 100vh;
  padding: 30px;
  box-sizing: border-box;
  .card {
    background: #fff;
    border-radius: 20px;
  }
  .section {
    padding: 30px 30px 40px 30px;
    .section__title {
      line-height: 3;
      color: #1a1a1a;
      font-size: 28px;
      font-weight: 500;
    }
    .textarea-box {
      border-radius: 15px;
      border: 1px solid #f5f5f5;
      padding: 20px;
    }
  }
  .tip {
    padding: 0 30px;
    width: -webkit-fill-available;
    color: #7d7c7c;
    text-align: justify;
    display: inline-block;
    margin: 30px 0;
    font-size: smaller;
    line-height: 1.5;
    text-align: right;
  }
  .btn {
    width: 100%;
    height: 78px;
    margin: 60px 0;
    border: none;
    border-radius: 39px;
    background: #ff2b21;
    font-size: 28px;
    color: #fff;
  }
}
</style>